module.exports = __webpack_public_path__ + "img/dagana.1cd168bb.jpg";